export function firstOrDefault<T>(
    arr: T[],
    predicate?: (item: T) => boolean,
    def: T | null = null,
): T | null {
    if (!arr || arr.length === 0) return def;
    if (!predicate) return arr[0] || def;
    return arr.find(predicate) ?? def;
}
